import React, { useState, useEffect } from 'react';
import Filters from './Filters';

const Sidebar = ({ 
  visibleHotspots, 
  preloadedImages, 
  focusedHotspot, 
  handleCardClick, 
  handleLinkClick,
  selectedCategories,
  setSelectedCategories,
  allSelected,
  setAllSelected,
  filtersVisible,
  setFiltersVisible,
  mobileView,
  setMobileView
}) => {
  const [displayLimit, setDisplayLimit] = useState(10);
  const isMobile = window.innerWidth <= 768;
  const itemsPerPage = isMobile ? 5 : 10;
  
  useEffect(() => {
    setDisplayLimit(itemsPerPage);
  }, [itemsPerPage]);

  const showMoreItems = () => {
    setDisplayLimit(prev => prev + itemsPerPage);
  };

  const visibleItems = visibleHotspots.slice(0, displayLimit);
  const hasMoreItems = visibleHotspots.length > displayLimit;

  return (
    <div className={`sidebar ${mobileView === 'list' ? 'mobile-visible' : 'mobile-hidden'}`}>
      <div className="filters-container">
        <Filters
          selectedCategories={selectedCategories}
          setSelectedCategories={setSelectedCategories}
          allSelected={allSelected}
          setAllSelected={setAllSelected}
          filtersVisible={filtersVisible}
          setFiltersVisible={setFiltersVisible}
        />
        <button 
          className="view-toggle-button"
          onClick={() => setMobileView(mobileView === 'map' ? 'list' : 'map')}
        >
          {mobileView === 'map' ? 'Liste' : 'Carte'}
        </button>
      </div>
      <div className="hotspot-list">
        {visibleItems.map((hotspot, index) => {
          const imageUrl = preloadedImages[hotspot.name];
          return (
            <div 
              key={index} 
              className={`hotspot-card ${focusedHotspot === hotspot.name ? 'focused' : ''}`}
              onClick={() => handleCardClick(hotspot)}
              data-hotspot={hotspot.name}
            >
              {imageUrl && <img src={imageUrl} alt={hotspot.name} />}
              <div className="hotspot-card-content">
                <h2>{hotspot.name}</h2>
                <p>{hotspot.description}</p>
                {hotspot.link && (
                  <button 
                    onClick={(e) => {
                      e.stopPropagation();
                      handleLinkClick(hotspot.link);
                    }} 
                    className="popup-link"
                  >
                    Voir le projet
                  </button>
                )}
              </div>
            </div>
          );
        })}
        {hasMoreItems && (
          <div className="show-more-container">
            <button className="show-more-button" onClick={showMoreItems}>
              Voir plus
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Sidebar;